// A round has a bonus card once one has been saved for it; the API's `status` is 1 then.
export const isSetUp = (round) => round?.status === 1
